let _this;
export default {
  name: "previewPDF",
  props:['previewInfo'],
  data(){
    return{
      trackInfo:{
        head:{},
        titleData:[],
        details:{},
        isFace:'',
      },
    }
  },
  watch:{
    previewInfo:{
      handler(nv){
        if(nv){
          this.getTrackInfo(nv);
        }
      },
      deep:true
    }
  },
  mounted() {
    _this = this;
    this.getTrackInfo(this.previewInfo);
  },

  methods:{
    getTrackInfo:function(nv){
      let obj = JSON.parse(JSON.stringify(nv));
      this.trackInfo = obj;

    }
  }
}



// WEBPACK FOOTER //
// ./src/admin/components/commonComponents/previewFaceTrackingPDF.js